"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfirmationButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _ActionButton = _interopRequireDefault(require("../ActionButton"));
var _ConfirmationModal = _interopRequireDefault(require("../ConfirmationModal"));
var _external = require("../../external");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const generateTitle = title => {
  if (typeof title === "string") {
    return title;
  }
  if (typeof title === "number") {
    return title.toString();
  }
  return null;
};
/**
 * `ConfirmationButton` is a specialised version of the [ActionButton](?path=/docs/actionbutton--default-story) component that uses a [ConfirmationModal](?path=/docs/confirmationmodal--default-story) to prompt a confirmation from the user before executing an action.
 */
const ConfirmationButton = _ref => {
  let {
    confirmationModalProps,
    onHoverText,
    shiftClickEnabled = false,
    showShiftClickHint = false,
    preModalOpenHook,
    ...actionButtonProps
  } = _ref;
  const {
    openPortal,
    closePortal,
    isOpen,
    Portal
  } = (0, _external.usePortal)();
  const handleCancelModal = () => {
    closePortal();
    if (confirmationModalProps.close) {
      confirmationModalProps.close();
    }
  };
  const handleConfirmModal = e => {
    closePortal();
    confirmationModalProps.onConfirm(e);
  };
  const handleShiftClick = e => {
    if (e.shiftKey) {
      confirmationModalProps.onConfirm(e);
    } else {
      openPortal(e);
    }
  };
  const handleClick = e => {
    if (preModalOpenHook) {
      const result = preModalOpenHook(e);
      if (!result) return;
    }
    shiftClickEnabled ? handleShiftClick(e) : openPortal(e);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isOpen && /*#__PURE__*/_react.default.createElement(Portal, null, /*#__PURE__*/_react.default.createElement(_ConfirmationModal.default, _extends({}, confirmationModalProps, {
    close: handleCancelModal,
    confirmButtonLabel: confirmationModalProps.confirmButtonLabel,
    onConfirm: handleConfirmModal
  }), confirmationModalProps.children, showShiftClickHint && /*#__PURE__*/_react.default.createElement("p", {
    className: "p-text--small u-text--muted u-hide--small"
  }, "Next time, you can skip this confirmation by holding", " ", /*#__PURE__*/_react.default.createElement("code", null, "SHIFT"), " and clicking the action."))), /*#__PURE__*/_react.default.createElement(_ActionButton.default, _extends({}, actionButtonProps, {
    onClick: handleClick,
    title: generateTitle(onHoverText !== null && onHoverText !== void 0 ? onHoverText : confirmationModalProps.confirmButtonLabel)
  }), actionButtonProps.children));
};
exports.ConfirmationButton = ConfirmationButton;
var _default = exports.default = ConfirmationButton;